import { render, staticRenderFns } from "./ConfigRadio.vue?vue&type=template&id=1799af2d&scoped=true&"
import script from "./ConfigRadio.vue?vue&type=script&lang=js&"
export * from "./ConfigRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799af2d",
  null
  
)

export default component.exports